// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'laptop';

export const Component = () => (
  <path d='M24.521 17.752h-.958V4.485c0-.431-.143-.766-.431-1.054A1.408 1.408 0 0 0 22.078 3H2.442c-.431 0-.766.144-1.005.431-.288.288-.432.623-.48 1.054v13.267H0v1.436c0 .719.24 1.293.719 1.725.479.478 1.054.718 1.724.766h19.636c.67-.048 1.245-.288 1.724-.766.479-.432.719-1.006.719-1.725v-1.436Zm-22.558 0V4.485c0-.335.144-.479.48-.479h19.635c.335 0 .479.144.479.48v13.266H1.963Zm21.6.957v.48c0 .43-.143.766-.431 1.053a1.408 1.408 0 0 1-1.054.431H2.442c-.431 0-.766-.143-1.005-.43-.288-.288-.432-.623-.48-1.055v-.479h8.861v1.006h4.885v-1.006h8.86Z' />
);

export const viewBox = '0 0 25 25';
